import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlSegment, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard {

  constructor(private _authService: AuthService, private router: Router) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | boolean {
    if (!this.hasTitleProperty(route)) {
      console.error('Route does not have a title property:', route);
      this.router.navigate(['/']);
      return false;
    }
    return this._authService.isLoggedIn();
  }

  canMatch(route: any, segments: UrlSegment[]): Observable<boolean> | boolean {
    return this._authService.isLoggedIn();
  }

  canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | boolean {
    return this._authService.isLoggedIn();
  }

  private hasTitleProperty(route: ActivatedRouteSnapshot): boolean {
    return !!route.data && !!route.data.title;
  }
}

